import $ from 'jquery';

export default class CategoryForm {
  constructor({
    $el,
    $container,
    targetSelector,
  } = {}) {
    this.$form = $el;
    this.$container = $container;
    this.targetSelector = targetSelector;

    this.$form.on('change', (...args) => this.onChange(...args));
  }

  onChange() {
    const $entries = this.$container.find(this.targetSelector);
    const $years = this.$container.children();
    const data = this.$form.serializeArray().map(({ value }) => parseInt(value, 10));

    $entries.each(
      (i, el) => $(el).toggleClass(
        '_hidden',
        $.inArray($(el).data('category'), data) === -1,
      ),
    );

    $years.each(
      (i, el) => $(el).toggleClass(
        '_hidden',
        $(el).find(`${this.targetSelector}:not(._hidden)`).length === 0,
      ),
    );

    return this;
  }
}
